import { ITreeNodeInstance } from '@infotech-soe/merps/types/Tree';
import { TDatabaseId } from '@infotech-soe/metaschema';
import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';

import UniqueId from '../../services/uid/UniqueId';
import { CategoryTreeNode } from '../../store/slices/dm-trees/CategoryTreeNode';

export enum DisableNodeStrategy {
  SINGLE,
  RECURSIVE,
}

export interface ICategoryTreeNode {
  id: TDatabaseId;
  parentId: TDatabaseId | null;
  children: TDatabaseId[];
  hasAccess: boolean;
  hasChildren: boolean;
  level: number;
  name: string;
  label: string;
  first: boolean;
  last: boolean;
  nodePath: ImmutableSet<TDatabaseId>;
  skipLevels: number[];
  disableStrategy: DisableNodeStrategy;
  withCheckbox?: boolean;
  readonly disabled: boolean;
  readonly root: boolean;
  readonly firstInRoot: boolean;

  addChildNode(node: ICategoryTreeNode): void;

  addHiddenChildNode(node: ICategoryTreeNode): void;

  inheritProperties(parentNode: ICategoryTreeNode): void;

  toServerModel(): ITreeNodeInstance & { name: string };
}

export interface CategoryTreeStateEntity {
  categoryId: UniqueId;
  treeRootId?: TDatabaseId | null;
  formId?: UniqueId;
  nodes: CategoryTreeNode[];
  activeId: TDatabaseId | null;
  hierarchyRootId: TDatabaseId | null;
  checkedNodes: ImmutableSet<TDatabaseId>;
  expandedNodes: ImmutableSet<TDatabaseId>;
  pendingNodes: ImmutableSet<TDatabaseId>;
  childrenCache: ImmutableMap<TDatabaseId, ITreeNodeInstance[]>;
  disabledQueue?: ImmutableMap<TDatabaseId, DisableNodeStrategy>;
  refreshHierarchyRootId?: TDatabaseId | null;
  refreshIsExpandedNode?: boolean;
}
